import { Box, Grid } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { FC, ReactNode } from "react";

import LvtUrls from "@/utilities/types/lvtUrls";

import VerticalNavBar from "../components/VerticalNavBar/VerticalNavBar";


interface SideNavLayoutProps {
    children?: ReactNode | ReactNode[];
    urls: LvtUrls;
}

const usePageStyles = makeStyles(() =>
    createStyles({
        app: { flexWrap: "nowrap" },
        page: {
            flexGrow: 1,
            overflowX: "hidden",
        },
    }),
);

const SideNavLayout: FC<SideNavLayoutProps> = ({ children, urls }) => {
    const pageClasses = usePageStyles();

    return (
        <Grid container className={clsx("app", pageClasses.app)}>
            <Grid item>
                <Box width={72} position="relative">
                    <VerticalNavBar urls={urls} />
                </Box>
            </Grid>
            <Grid item className={pageClasses.page}>
                <main>
                    {children}
                </main>
            </Grid>
        </Grid>
    );
};

export default SideNavLayout;
